<template>
  <div class="form-item">
    <div class="form-item-header">
      <div class="form-item-title">
        <slot name="form-item-label">{{label}}
          <tooltip-icon v-if="tip" placement="right" :content="tip" ref="tooltipIcon"></tooltip-icon>
          <slot name="form-item-annotation">
            <div v-if="annotation" class="annotation">{{annotation}}</div>
          </slot>
        </slot>
      </div>
    </div>
    <div class="form-item-body">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'FormItem',
  props: {
    label: String,
    tip: String,
    annotation: String
  },
  mounted () {
    if (this.$refs.tooltipIcon) {
      this.$nextTick(() => {
        this.$refs.tooltipIcon.$el.setAttribute('tabindex', '-1')
      })
    }
  }
}

</script>

<style scoped>
  .form-item {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    border-left: 1px solid #c0d5ef;
    border-right: 1px solid #c0d5ef;
    border-bottom: 1px solid #c0d5ef;
    min-height: 90px;
    font-size: 1rem;
  }

  .form-item:first-child {
    border-top: 1px solid #c0d5ef;
  }

  .form-item > .form-item-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    text-align: left;
    background: #6ba7ef;
    width: 218px;
    color: #fff;
    padding: 20px;
    font-weight: 700;
  }

  .form-item > .form-item-body {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 14px;
    width: 100%;
    justify-content: center;
  }

  .icon-tip {
    font-size: 1.1rem;
    padding-left: 6px;
  }

  .annotation {
    display: block;
    font-size: 0.75rem;
    font-weight: normal;
    text-indent: -1em;
    margin: 0 0 0 1em;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/form-item.vue